import Bowser from 'bowser';

export interface BowserParseDataInterface {
    getBrowserVersion(): string;
    getBrowserName(): string;
    getOSName(): string;
    getOSVersion(): string;
    getPlatformType(): string;
    getUA(): string;
}

const bowserInterfaceMockup: BowserParseDataInterface = {
    getBrowserVersion() {
        return 'unknown';
    },
    getBrowserName() {
        return 'unknown';
    },
    getOSName() {
        return 'unknown';
    },
    getOSVersion() {
        return 'unknown';
    },
    getPlatformType() {
        return 'unknown';
    },
    getUA() {
        return 'unknown';
    }
};

export function bowserParseData(): BowserParseDataInterface {
    return typeof window === 'object'
        ? Bowser.getParser(window.navigator.userAgent)
        : bowserInterfaceMockup;
}
